let rehydrating = false;

export function setIsRehydrating(isRehydrating: boolean) {
  rehydrating = isRehydrating;
}

export function isRehydrating() {
  return rehydrating;
}
